import { Component, OnInit, OnDestroy, ViewChild, Input, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { format } from 'date-fns';
import {default as _} from 'lodash';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse,HttpHeaders } from '@angular/common/http';
import { asBlob, generateCsv } from 'export-to-csv';
import saveAs from 'file-saver';
import { MenuItem, TreeNode,ConfirmationService,MessageService } from 'primeng/api';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UserService } from 'app/Shared/Services/user.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { DataService } from 'app/Shared/Services/data.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { TableModule } from 'primeng/table';
import { TreeTable, TreeTableModule } from 'primeng/treetable';
import { ButtonModule } from 'primeng/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CommentViewerComponent } from 'app/Shared/Component/comment-viewer/comment-viewer.component';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { default as gridColumnsJSON } from 'app/Pages/reg-inquiry/inquiry-list-column.json';
import { FileUploadModule } from 'primeng/fileupload';
import { PopoverModule } from 'primeng/popover';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ContextMenu } from 'primeng/contextmenu';
import { FinraInquiryServiceService } from 'app/Pages/reg-inquiry/finra-inquiry/finra-inquiry-service.service';

@Component({
  selector: 'app-finra-reg-inquiry-list',
  imports: [CommonModule, ButtonModule, MatProgressSpinnerModule, MatTooltipModule, FormsModule, MatProgressSpinnerModule, 
            Select, DatePickerModule, TableModule, TreeTableModule, DialogModule, FormsModule, ToastModule, ConfirmDialogModule,
            CommentViewerComponent, ExportToCSVSComponent,FileUploadModule, PopoverModule, ContextMenu],
  templateUrl: './finra-reg-inquiry-list.component.html',
  styleUrl: './finra-reg-inquiry-list.component.scss'
})
export class FinraRegInquiryListComponent implements OnInit, OnDestroy {
  @Input('defaultFilters') DefaultFilterArray: any;
  @Output() reloadScreen: EventEmitter<any> = new EventEmitter<any>();
  @Output() editInquiryDetail: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('cm') cm!: ContextMenu;
  @ViewChild(('tt')) dt!: TreeTable;
  inquiryContextItems: MenuItem[] | undefined;
  httpHeaders!: HttpHeaders;
  HTTPInquirySubscribedAPI: any;
  HTTPSubscribedAPI: any;
  inquiryList: any = [];
  regInquiryList: TreeNode[] = [];
  selectedRegInquiryNodes: TreeNode[] = [];
  InquiryScreenDataDetails: any = [];
  QueryScreenDataDetails: any = [];
  queryDataSet: any[] = [];
  buttonCaption: string = "Collapse";
  expandCollapseAll = "Expand All";
  isDisableFileUpload: boolean = false;
  maximumDateTime: any = new Date();
  FileUploadUrl: any;
  uploadedFiles: any[] = [];
  uploadedFileId: any;
  uploadedFileContents: any = [];
  uploadedFileName: string = "";
  inquiryDataDetails: any = [];
  subscription!: Subscription;
  GridColumns: any = gridColumnsJSON["reg_inquiry_Columns"];
  exportGridColumns: any = gridColumnsJSON["reg_inquiry_Columns"];
  InquiryGridColumns: any = gridColumnsJSON["inquiry_form_columns"];
  queryGridColumns = gridColumnsJSON["query_form_columns"];
  commentGridColumns!: any;
  isLoadingResults = true;
  sortData: any = { field: 'ti.tag', order: 'desc' };
  totalRecords: any = 0;
  pageNumber: any = 1;
  priviousStartLimit: any;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  sortClickCounter: number = 0;
  inquiryDataSet: any[] = [];
  tblCols: any = [];
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  tbldatamsg = 'L o a d i n g . . . . .';
  selectedCommentRow: any = [];
  isDisplayCommentViewer: boolean = false;
  isDisplayAddInquiryViewer: boolean = false;
  commentStaticFilters!: any[];
  commentAPIDetail: any;
  inquiryEditableCols: any = [];
  inquiryQueryEditableCols: any = [];

  constructor(private UserService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private urlsService: UrlsService,
    private sharedHttpClientService: SharedHttpClientService,
    public dataService: DataService,
    public constantService: ConstantService,
    private changeDetector: ChangeDetectorRef,
    public FinraInquiryServiceService: FinraInquiryServiceService
  ) {
    // Initialize HTTP Header Token for Accessing API
    this.httpHeaders = this.sharedHttpClientService.fileUploadToken();

    this.tblCols = [];
    this.inquiryEditableCols = ["Inquiry Tag", "Inquiry Date", "Inquiry Requestor"];
    this.inquiryQueryEditableCols = ["CATReporterIMID", "Trade Date", "Order ID", "Route ID", "Trade ID", "Symbol", "Destination"];
  }
  
  ngOnInit() {
    this.FileUploadUrl = this.urlsService.setAPIURl(APIURL.InquiryQueryFileUploadURL) + "/" + this.UserService.getActiveMPID() + "/" +this.UserService.getyyyyMMddDateFormate(this.maximumDateTime)+ "/" + this.UserService.getUserFirstName() + "/" + "upload";
    /* Dynamically Add Rows Per Page for Finra Inquiry List Screen only */
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.rowcount;
    
    this.Limit = { 'Start': 0, 'End': this.rowcount };
    this.rowsPerPageOptions = [...this.constantService.DEFAULT_ROWSPERPAGEOPTION];

    this.resetInquiryQueryTableData(); // Reset Inquiry-Query TreeViewer Table
    this.screenData();
    this.getColumns();
    this.getData();
    this.initializeContextMenuItems();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.resetInquiryQueryTableData(); // Reset Inquiry-Query TreeViewer Table
        this.getData();
      }
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(!changes['DefaultFilterArray']['firstChange']) {
      // Proceed with Retrieving Data and preserving Inquiry/Inquiry Queries selection at the time of User Actions (e.g. - Edit Inquiry/Import Query CSV for Inquiry)
      if((this.FinraInquiryServiceService.userAction && this.FinraInquiryServiceService.userAction.length > 0) && Object.keys(this.FinraInquiryServiceService.activeInquiry).length > 0) {
        this.getData(false);
      } else {
        this.resetInquiryQueryTableData(); // Reset Inquiry-Query TreeViewer Table
        this.emitterService.isResetGridLimit.emit(true);
        this.getData();
      }
    }
  }

  resetInquiryQueryTableData() {
    this.FinraInquiryServiceService.activeInquiry = new Object();

    if(this.dt) {
      this.dt.first = 0;
    }
    this.totalRecords = 0;
    this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
    this.regInquiryList = [];
    this.selectedRegInquiryNodes = []; // Reset Selected Reg-Inquiries List
    this.tbldatamsg = "No data found";
    this.changeDetector.detectChanges(); // After modifying selectedRegInquiryNodes
  }

  getColumns() {
    let column: any;
    column = this.GridColumns;
    if (column !== null || column !== undefined) {
      this.tblCols = this.gridService.getGridColumns(column);
    }

    // Add Dropdown Values for Edit Inquiry/Query Dropdown Fields
    let InquiryRequestorIndex = this.tblCols.findIndex((rowObj: any) => rowObj.header === "Inquiry Requestor");
    let QueryCATMPIDIndex = this.tblCols.findIndex((rowObj: any) => rowObj.header === "CATReporterIMID");
    
    this.tblCols[InquiryRequestorIndex].dropdownvalue = this.constantService["inquirySelectionValues"][0]["inquiryFields"]["inquiryRequestor"];
    this.tblCols[QueryCATMPIDIndex].dropdownvalue = this.UserService.getMPLIDList().map((resultObj: any) => resultObj.mpid);
  }

  screenData() {
    /* Get all Inquiry fields to Display */
      this.InquiryScreenDataDetails = [];
      for (let i = 0; i < Object.keys(this.InquiryGridColumns).length; i++) {
        this.InquiryScreenDataDetails.push({
          "ui_Field_Name": this.InquiryGridColumns[i]["ui_columnname"],
          "field_Name": this.InquiryGridColumns[i]["mappingkey"],
          "value": "",
          "datatype": this.InquiryGridColumns[i]["datatype"],
          "display": this.InquiryGridColumns[i]["display"],
          "db_columnname": this.InquiryGridColumns[i]["db_columnname"],
          "dropdown": this.InquiryGridColumns[i]["dropdown"],
          "dropdowntype": this.InquiryGridColumns[i]["dropdowntype"],
          "dropdownvalue": (Object.hasOwn(this.constantService["inquirySelectionValues"][0]["inquiryFields"], this.InquiryGridColumns[i]["mappingkey"]) ? this.constantService["inquirySelectionValues"][0]["inquiryFields"][this.InquiryGridColumns[i]["mappingkey"]] : this.InquiryGridColumns[i]["dropdownvalue"]),
          "isDisable": this.InquiryGridColumns[i]["disabled"],
          "placeholder": (this.InquiryGridColumns[i]["placeholder"] ? this.InquiryGridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.InquiryGridColumns[i]["maxlength"] ? this.InquiryGridColumns[i]["maxlength"] : ""),
          "isrequired": (this.InquiryGridColumns[i]["isrequired"] ? this.InquiryGridColumns[i]["isrequired"] : false),
          "regexpressions": (this.InquiryGridColumns[i]["regexpressions"] ? this.InquiryGridColumns[i]["regexpressions"] : "")
        });
      }

    /* Get all Query fields to Display */
      this.QueryScreenDataDetails = [];
      for (let i = 0; i < Object.keys(this.queryGridColumns).length; i++) {
        this.QueryScreenDataDetails.push({
          "ui_Field_Name": this.queryGridColumns[i]["ui_columnname"],
          "field_Name": this.queryGridColumns[i]["mappingkey"],
          "value": "",
          "datatype": this.queryGridColumns[i]["datatype"],
          "display": this.queryGridColumns[i]["display"],
          "db_columnname": this.queryGridColumns[i]["db_columnname"],
          "dropdown": this.queryGridColumns[i]["dropdown"],
          "dropdowntype": this.queryGridColumns[i]["dropdowntype"],
          "dropdownvalue": (Object.hasOwn(this.constantService["inquirySelectionValues"][0]["inquiryQueryFields"], this.queryGridColumns[i]["mappingkey"]) ? this.constantService["inquirySelectionValues"][0]["inquiryQueryFields"][this.queryGridColumns[i]["mappingkey"]] : this.queryGridColumns[i]["dropdownvalue"]),
          "isDisable": this.queryGridColumns[i]["disabled"],
          "placeholder": (this.queryGridColumns[i]["placeholder"] ? this.queryGridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.queryGridColumns[i]["maxlength"] ? this.queryGridColumns[i]["maxlength"] : ""),
          "isrequired": (this.queryGridColumns[i]["isrequired"] ? this.queryGridColumns[i]["isrequired"] : false),
          "regexpressions": (this.queryGridColumns[i]["regexpressions"] ? this.queryGridColumns[i]["regexpressions"] : "")
        });
      }

  }

  getData(isResetTreeTable?: boolean) {
    // Cancel All Previously Pending Status APIs
    if (this.HTTPInquirySubscribedAPI) {
      this.HTTPInquirySubscribedAPI.unsubscribe();
    }

    this.isLoadingResults = true;
    this.inquiryList = [];
    // Reset Tree-Viewer Query Data
    this.regInquiryList = [];
    this.changeDetector.detectChanges();

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    /* Save Inquiry API */
    let APIParams = {
      CATReporterIMID: this.UserService.getActiveMPID(),
      user: this.UserService.getUserName(),
      userName: this.UserService.getUserFirstName(),
      data: filterData,
      sortField: this.sortData.field,
      sortOrder: this.sortData.order
    };
    this.HTTPInquirySubscribedAPI = this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.getInquiryList
      ), APIParams)
      .subscribe({
        next: (res:any) => {
          this.isLoadingResults = false;
          this.inquiryList = res.Data;
          if(isResetTreeTable===false && Object.keys(this.FinraInquiryServiceService.activeInquiry).length > 0) {
            this.setInquiryFilter(this.FinraInquiryServiceService.activeInquiry);
            this.regInquiryList = [];
            this.selectedRegInquiryNodes = []; // Reset Selected Reg-Inquiries List
            this.changeDetector.detectChanges(); // After modifying selectedRegInquiryNodes
          } else {
            this.resetInquiryQueryTableData(); // Reset Inquiry-Query TreeViewer Table
          }

          if(res.status === false) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: res.message });
          }
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
        this.tbldatamsg = "No data found";
      }
    });
  }

  initializeContextMenuItems() {
    this.inquiryContextItems = [
      {
          label: 'Edit',
          icon: 'fa fa-fw fa-edit',
          command: () => {
              this.editInquiryDetail.emit(this.FinraInquiryServiceService.selectedInquiryRowObj);
          }
      },
      /* (Keeping it Disable for now and can enable it for future use whenever needed)
      {
          label: 'Comment',
          icon: 'fa fa-fw fa-comment',
          command: () => {
              this.applycomment(this.FinraInquiryServiceService.selectedInquiryRowObj, "InquiryRow");
          }
      }, */
      {
          label: 'Delete',
          icon: 'fa fa-fw fa-trash',
          command: () => {
              this.removeInquiries(this.FinraInquiryServiceService.selectedInquiryRowObj, "InquiryRow");
          }
      }
    ];
  }

  getInquiryQueryData() {
    // Cancel All Previously Pending Status APIs
    if (this.HTTPSubscribedAPI) {
      this.HTTPSubscribedAPI.unsubscribe();
    }

    this.isLoadingResults = true;
    this.regInquiryList = [];
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    /* Save Inquiry API */
    let APIParams = {
      CATReporterIMID: this.UserService.getActiveMPID(),
      user: this.UserService.getUserName(),
      userName: this.UserService.getUserFirstName(),
      data: filterData,
      rowDataObject: this.FinraInquiryServiceService.activeInquiry,
      sortField: this.sortData.field,
      sortOrder: this.sortData.order,
      startLimit: this.Limit.Start,
      endLimit: this.Limit.End
    };
    this.HTTPSubscribedAPI = this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.getInquiryList
      ), APIParams)
      .subscribe({
        next: (res:any) => {
          this.tbldatamsg = '';
          this.isLoadingResults = false;
          this.totalRecords = res.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.regInquiryList = [...res.Data];
          this.changeDetector.detectChanges();

          if (res.totalCount == 0) {
            this.tbldatamsg = "No data found";
          }
          if(res.status === false) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: res.message });
          }
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
        this.tbldatamsg = "No data found";
      }
    });
  }

  setInquiryFilter(inquiry: any) {
    this.FinraInquiryServiceService.activeInquiry = {...inquiry};

    /* Dynamically Add Rows Per Page for Finra Inquiry Query List Tree-Viewer Table only */
    this.startLimit = 0;
    this.endLimit = this.rowcount;
    if(this.dt) {
      this.dt.first = 0;
    }

    this.getInquiryQueryData();
  }

  removeInquiryFilterQuery(inquiry: any) {
    this.resetInquiryQueryTableData(); // Reset Inquiry-Query TreeViewer Table
    this.startLimit = 0;
    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
  }

  getFormat(dateObj: any) {
    let convertedDateObj = new Date(dateObj);
    return this.UserService.getyyyyMMddDateFormate(convertedDateObj);
  }

  onContextMenu(event: any, inquiry: any) {
    this.FinraInquiryServiceService.selectedInquiryRowObj = inquiry;
    this.cm.target = event.currentTarget;
    this.cm.show(event);
  }

  onHide() {
    this.FinraInquiryServiceService.selectedInquiryRowObj = new Object();
  }

  exapandORcollapse(nodes: any) {
    if (this.buttonCaption === "Expand") {
      this.buttonCaption = "Collapse";
      this.expandCollapseAll = "Expand All";
      this.collapseAll(nodes);
    } else if (this.buttonCaption === "Collapse") {
      this.buttonCaption = "Expand";
      this.expandCollapseAll = "Collapse All";
      this.exapandAll(nodes);
    }
    //refresh the data
    this.regInquiryList = [...this.regInquiryList];
  }

  collapseAll(nodes: any) {
    for (let node of nodes) {
      if (node.children) {
        if (node.expanded || node.expanded == undefined) {
          node.expanded = false;
          this.collapseAll(node.children);
        }
      }
    }
    //refresh the data
    this.regInquiryList = [...this.regInquiryList];
  }

  exapandAll(nodes: any) {
    for (let node of nodes) {
      if (node.children) {
        if (!node.expanded || node.expanded == undefined) {
          node.expanded = true;
          this.exapandAll(node.children);
        }
      }
    }
    //refresh the data
    this.regInquiryList = [...this.regInquiryList];
  }

  changePage(event: any) {

    /* Sorting Logic */
      if(event.multiSortMeta) {
        /* Searching Field to add Prefix for DB Field (DB Table Inquiries/InquiryQueries/InquiryQueriesResults) */
          if(gridColumnsJSON["inquiry_Columns"].filter((rowObj: any) => rowObj.db_columnname===event.multiSortMeta[0].field).length > 0) {
            if(_.includes(['File_Name'], event.multiSortMeta[0].field)) {
              this.sortData.field = "tcflh." + event.multiSortMeta[0].field;
            } else  {
              this.sortData.field = "ti." + event.multiSortMeta[0].field;
            }
          } else if(gridColumnsJSON["query_form_columns"].filter((rowObj: any) => rowObj.db_columnname===event.multiSortMeta[0].field).length > 0) {
            this.sortData.field = "tiq." + event.multiSortMeta[0].field;
          } else if(gridColumnsJSON["inquiry_result_Columns"].filter((rowObj: any) => rowObj.db_columnname===event.multiSortMeta[0].field).length > 0) {
            this.sortData.field = "tiqr." + event.multiSortMeta[0].field;
          }
        /* End of Searching Field to add Prefix for DB Field (DB Table Inquiries/InquiryQueries/InquiryQueriesResults) */

        let sortOrder = event.multiSortMeta[0].order === 1 ? 'asc' : 'desc';
        this.sortData.order = sortOrder;
      }
    /* End of Sorting Logic */

    /* Paging logic */
      this.startLimit = event.first;
      this.rowcount = event.rows;
      this.endLimit = this.startLimit + this.rowcount;

      if (this.endLimit > this.totalRecords) {
        this.endLimit = this.totalRecords;
      }
      this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
      this.priviousStartLimit = this.startLimit;
      this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    /* End of Paging logic */

    if(Object.keys(this.FinraInquiryServiceService.activeInquiry).length > 0) {
      this.getInquiryQueryData();
    }

  }

  onNodeExpand(event: any) {
    
    this.isLoadingResults = true;

    let node = event.node;

    // Cancel All Previously Pending Status APIs
    if (this.HTTPSubscribedAPI) {
      this.HTTPSubscribedAPI.unsubscribe();
    }

    this.tbldatamsg = 'L o a d i n g . . . . .';

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    /* Save Inquiry API */
    let APIParams = {
      CATReporterIMID: this.UserService.getActiveMPID(),
      user: this.UserService.getUserName(),
      userName: this.UserService.getUserFirstName(),
      data: filterData,
      rowDataObject: node.data,
      sortField: this.sortData.field,
      sortOrder: this.sortData.order,
      startLimit: this.constantService.NUMBER_0,
      endLimit: this.constantService.NUMBER_MAX_EXPORT_ROWS
    };
    this.HTTPSubscribedAPI = this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.getInquiryList
      ), APIParams)
      .subscribe({
        next: (res:any) => {
          this.isLoadingResults = false;
          node.children = res.Data; // Receive Child Data
          this.regInquiryList = [...this.regInquiryList]; // Reset Reg Inquiry Tree Viewer List Data
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
      }
    });

    this.changeDetector.markForCheck();this.changeDetector.detectChanges();
  }

  onRowSelect(value: any, rowData: any) {

    if(["Comment"].includes(value)) {
      this.applycomment(rowData, "QueryRow");
    } else if(["Delete"].includes(value)) {
      this.removeInquiries(rowData, "QueryRow");
    }
  }

  removeInquiries(rowData: any, rowType: any) {
    let msg: string = '';
    let executedInquiryIds: any;
    let executedQueryIds: any;
    let APIPayload: any;

    if(rowType && rowType==="InquiryRow") {

      msg = 'Do you want to Remove Inquiry records?';

      executedInquiryIds = [this.FinraInquiryServiceService.selectedInquiryRowObj.inquiryId];
      APIPayload = {
        inquiryIds: executedInquiryIds,
        recordType: "Inquiry",
        Action: "Delete",
        CATReporterIMID: this.UserService.getActiveMPID(),
        userName: this.UserService.getUserFirstName()
      };
    } else if(rowType && rowType==="QueryRow" && rowData.node.data.parentLevel===2) {
      let optedRowExistance = this.selectedRegInquiryNodes.filter((rowObj) => (rowObj.data.inquiryId === rowData.node.data.inquiryId && rowObj.data.queryId===rowData.node.data.queryId && rowObj.data.rowIndex===rowData.node.data.rowIndex));
      if(optedRowExistance.length === 0) {
        this.selectedRegInquiryNodes.push(rowData.node);
      }
      this.selectedRegInquiryNodes = [...this.selectedRegInquiryNodes];
      this.changeDetector.detectChanges(); // After modifying selectedRegInquiryNodes

      msg = 'Do you want to Remove Query records?';
      executedInquiryIds = this.selectedRegInquiryNodes.reduce((acc: any, rowObj: any) => {
        if (rowObj.data && !_.includes(acc, rowObj.data.inquiryId) && rowObj.data.parentLevel===2) {
            acc.push(rowObj.data.inquiryId);
        }
        return acc;
      }, []);
      executedQueryIds = this.selectedRegInquiryNodes.reduce((acc: any, rowObj: any) => {
        if (rowObj.data && !_.includes(acc, rowObj.data.queryId) && rowObj.data.parentLevel===2) {
            acc.push(rowObj.data.queryId);
        }
        return acc;
      }, []);
      APIPayload = {
        inquiryIds: executedInquiryIds,
        queryIds: executedQueryIds,
        recordType: "Query",
        Action: "Delete",
        CATReporterIMID: this.UserService.getActiveMPID(),
        userName: this.UserService.getUserFirstName()
      };
    }
    
    this.confirmationService.confirm({
      message: msg,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.isLoadingResults = true;
        this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.deleteInquiries), APIPayload)
          .subscribe({
            next: (Element:any) => {
              if(Element.status===true) {
                this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: Element.message });
                if(rowType && rowType==="InquiryRow") {
                  this.getData(false); // Remove Inquiry should preserve opted Inquiry & Display of its Queries Data in Grid Table
                } else if (rowType && rowType==="QueryRow" && rowData.node.data.parentLevel===2) {
                  this.getInquiryQueryData();
                }
              }
            },
            error: (err: HttpErrorResponse) => {
              this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Inquiry Deletion Failed!' });
              this.isLoadingResults= false;
            }
          });
      }
    });
  }

  applycomment(rowData: any, rowType: any) {

    this.selectedCommentRow = [];

    if(rowType && rowType==="InquiryRow") {

      this.selectedCommentRow.push(this.FinraInquiryServiceService.selectedInquiryRowObj); // Pass Opted Row for Comment Dialogbox

      // Comment Detail
      this.commentAPIDetail = {
        "GetCommentURL": APIURL.getInquiryComments,
        "AddCommentURL": APIURL.addInquiryComment,
        "DeleteCommentURL": APIURL.deleteInquiryComments,
        "Module": "Finra-Inquiry"
      };

      // Set Query-Comment Columns
      this.commentGridColumns = gridColumnsJSON['inquiry_comment_columns'];

      // Static Filters for Comment-Viewer Dialog
      this.commentStaticFilters = [{filterName: 'Inquiry Date', filterValue: this.FinraInquiryServiceService.selectedInquiryRowObj.inquiryDate, fieldName: 'inquiryDate'}, {filterName: 'Tag', filterValue: this.FinraInquiryServiceService.selectedInquiryRowObj.tag, fieldName: 'tag'}, {filterName: 'Inquiry Status', filterValue: this.FinraInquiryServiceService.selectedInquiryRowObj.status, fieldName: 'status'}, {filterName: 'Requestor', filterValue: this.FinraInquiryServiceService.selectedInquiryRowObj.inquiryRequestor, fieldName: 'inquiryRequestor'}];

    } else if(rowType && rowType==="QueryRow" && rowData.node.data.parentLevel===2) {

      this.selectedRegInquiryNodes = []; // Reset Selected Reg-Inquiries List
      this.selectedRegInquiryNodes = [...this.selectedRegInquiryNodes, rowData.node];
      this.changeDetector.detectChanges(); // After modifying selectedRegInquiryNodes

      this.selectedCommentRow.push(rowData.node.data); // Pass Opted Row for Comment Dialogbox

      // Comment Detail
      this.commentAPIDetail = {
        "GetCommentURL": APIURL.getQueryComments,
        "AddCommentURL": APIURL.addQueryComment,
        "DeleteCommentURL": APIURL.deleteQueryComments,
        "Module": "Finra-Inquiry-Query"
      };

      // Set Query-Comment Columns
      this.commentGridColumns = gridColumnsJSON['query_comment_columns'];

      // Static Filters for Comment-Viewer Dialog
      this.commentStaticFilters = [{filterName: 'Trade Date', filterValue: rowData.node.data.tradeDate, fieldName: 'tradeDate'}, {filterName: 'OrderID', filterValue: rowData.node.data.orderId, fieldName: 'orderId'}, {filterName: 'RouteID', filterValue: rowData.node.data.routeId, fieldName: 'routeId'}, {filterName: 'TradeID', filterValue: rowData.node.data.tradeId, fieldName: 'tradeId'}, {filterName: 'Symbol', filterValue: rowData.node.data.symbol, fieldName: 'symbol'}, {filterName: 'Destination', filterValue: rowData.node.data.destination, fieldName: 'destination'}];

    }

    this.isDisplayCommentViewer = true; // open Comment-Viewer Dialog

  }

  closeCommentDialogbox() {
    this.isDisplayCommentViewer = false;
  }

  allowtoUploadFile() {
    this.uploadedFiles = []; // Reset Uploaded File List

    // Allow User to Import CSV File only if User selects Single Inquiry
    if(Object.keys(this.FinraInquiryServiceService.activeInquiry).length === 0) {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_WARN, detail: 'Please Choose any one Inqiury for Importing CSV.' });
      return false;
    } else { 
      return true;
    }
  }

  onBeforeSend(event: any) {
    // Set HTTP Header Token for Accessing API
    this.httpHeaders = this.sharedHttpClientService.fileUploadToken();

  }

  getUploadedFileList(event: any) {
    this.uploadedFiles = [];
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
  }

  onCancelUpload(event: any) {
    this.uploadedFiles = [];
  }

  onUploadFile(event: any) {
    this.uploadedFiles = []; // Reset Uploaded File List

    // Receive Uploaded File ID from Upload File API Response
    if(event.originalEvent.body.length > 0) {
      if('uploadedFileId' in event.originalEvent.body[0]) {
        this.uploadedFileId = event.originalEvent.body[0].uploadedFileId;
      }
    }

    // Read Uploaded CSV File & display its content in Query Table
    this.uploadedFileContents = [];
    for (const file of event.files) {
      this.readFile(file); // Read File Name
    }
  }

  private readFile(file: File) {
    this.uploadedFileName = file.name; // Receive File Name

    const reader: FileReader = new FileReader();
    reader.readAsText(file); //
    reader.onload = () => {
        let csvData: any = reader.result;
        this.getCSVFileData(csvData); // Read & Store Parse CSV Data
        this.dipslayUploadedCSVFileData(); // Display File Uploaded Data in Query Table
        this.attachUploadedCSVFileData(); // Link All Imported Queries with Inquiry Ids
    };
  }

  getCSVFileData(csvData: any) {
    /* Read & Store Parse CSV Data */
      const regex = /,(?=(?:[^"]*"[^"]*")*(?![^"]*"))/;
      const rows = csvData.split("\n");
      const headers = rows[0].split(regex);

      for (let i = 1; i < rows.length-1; i++) {
          const values = rows[i].split(regex);
          const obj: any = {};
          for (let j = 0; j < headers.length; j++) {
              obj[headers[j].replace(/\s/g,'').toLowerCase().trim()] = values[j].trim();
          }
          this.uploadedFileContents.push(obj);
      }
    /* End of Read & Store Parse CSV Data */
  }

  dipslayUploadedCSVFileData() {
    this.queryDataSet = [];

    if(this.uploadedFileContents.length > 0) {
      let queryGridColumnKeys = {...this.queryGridColumns.map((obj) => obj.mappingkey)}; // Receive All Mapping Key from Grid JSON File
      // Create Empty Query Row JSON Object
      let queryRowObject: any = {};
      for (const key in queryGridColumnKeys) {
        queryRowObject[queryGridColumnKeys[key]] = null;
      }

      let fileRowKeys = Object.keys(this.uploadedFileContents[0]); // Receive All Uploaded File Columns

      for(let i=0; i<this.uploadedFileContents.length; i++) {
        let fileQueryRow = {...queryRowObject}; // Create Empty File Query Row

          let fileQueryRowKeys = Object.keys(fileQueryRow);
          for (let j=0;j<fileQueryRowKeys.length; j++) {
            if(fileRowKeys.includes(fileQueryRowKeys[j].toLocaleLowerCase())) {
              fileQueryRow[fileQueryRowKeys[j]] = (fileQueryRowKeys[j].toLocaleLowerCase().indexOf("date") > 0 ? (this.uploadedFileContents[i][fileQueryRowKeys[j].toLocaleLowerCase()].trim().length > 0 ? this.getFormat(this.uploadedFileContents[i][fileQueryRowKeys[j].toLocaleLowerCase()].trim()) : "") : this.uploadedFileContents[i][fileQueryRowKeys[j].toLocaleLowerCase()].trim());
            }
          }
        // Attach File Query Row in Query Display Table
        if(Object.values(fileQueryRow).some(elem => elem !== null && elem !== '')) {
          fileQueryRow["status"] = this.constantService["inquirySelectionValues"][0]["inquiryQueryFields"]["status"][0];
          this.queryDataSet.push(fileQueryRow);
        }
      }
    }
    this.queryDataSet = [...this.queryDataSet]; // Re-assign Query Display Table DataSet

    // Add User Action Log Entry for Uploading Query CSV File
    this.UserService.logUserActivity('Uploaded Query CSV File', ('Edit Inquiry'), {
      'Text1': 'File Uploaded Successfully | ' + (this.queryDataSet.length > 0 ? this.queryDataSet.length : 0) + ' records uploaded with file name: ' + this.uploadedFileName + ' with start time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}) + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
      'Text2': 'Completed Query CSV File Uploading'
    });
  }

  attachUploadedCSVFileData() {
    this.isLoadingResults = true;

    // Receive Inquiry Data Detail
    this.inquiryDataDetails = {};
    this.inquiryDataDetails = this.FinraInquiryServiceService.activeInquiry;

    /* Field Validations */
      if(!this.formFieldValidation()) {
        this.isLoadingResults = false;
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Please check required fields (e.g. Trade Date / CAT Reporter IMID)' });
      } else {
        this.isLoadingResults = false;

        /* Preparing Inquiry Parameter */
        this.inquiryDataDetails.fileId = (this.uploadedFileId && this.uploadedFileId>0 ? this.uploadedFileId : this.inquiryDataDetails.fileId);

        // Assign Inquiry Status while Edit Inquiry (e.g. - Modified | Re-initiated) by checking Inquiry Result Execution Privilege condition
        if(_.includes(["Deleted"], this.inquiryDataDetails.status)) {
          this.inquiryDataDetails.status = this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"][3];
          this.queryDataSet.forEach((elem)=>{elem.status = this.constantService["inquirySelectionValues"][0]["inquiryQueryFields"]["status"][3]});
        } else {
          this.inquiryDataDetails.status = this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"][1];
          this.queryDataSet.forEach((elem)=>{elem.status = this.constantService["inquirySelectionValues"][0]["inquiryQueryFields"]["status"][0]});
        }

        let inquiryObj = this.inquiryDataDetails;
        this.formatData(inquiryObj); // Formatting Inquiry Data

        /* Preparing Inquiry-Queries Parameters */
        let inquiryQueryArrayObj = [];
        if(this.queryDataSet.length > 0) {
          for(let i=0; i<this.queryDataSet.length; i++) {
            this.formatData(this.queryDataSet[i]); // Formatting Data
            if(!this.isEmptyObject(this.queryDataSet[i])) {
              inquiryQueryArrayObj.push({...this.queryDataSet[i]});
            }
          }
        }

        /* Save Inquiry API */
          let APIParams = {
            CATReporterIMID: this.UserService.getActiveMPID(),
            user: this.UserService.getUserName(),
            userName: this.UserService.getUserFirstName(),
            inquiryDetails: inquiryObj,
            inquiryQueryDetails: inquiryQueryArrayObj,
            userAction: "ImportQueryCSV"
          };

          /* Check If User Wants to Save Inquiry With OR Without Fetching Inquiry Result */
            this.FinraInquiryServiceService.userAction = "ImportQueryCSV";
            this.saveInquiryWithFetchResult(APIParams);
          /* End of Checking If User Wants to Save Inquiry With OR Without Fetching Inquiry Result */
        /* End of Saving Inquiry */
      }
    /* End of Field Validations */
  }

  formFieldValidation() {
    /* Inquiry Validation */
    let screenDataFields = this.InquiryScreenDataDetails;
    this.validateFields(this.inquiryDataDetails, screenDataFields); // Validating Inquiry Data

    /* Inquiry-Query Validation */
    if(this.queryDataSet.length > 0) {
      for(let i=0;i<this.queryDataSet.length;i++) {
        if(!this.isEmptyObject(this.queryDataSet[i])) {
          this.validateFields(this.queryDataSet[i], this.QueryScreenDataDetails); // Validating Inquiry Query Row Fields
        } else {
          delete this.queryDataSet[i].errorFields;
        }
      }
    }
    let QueryDataSetErrorArray = this.queryDataSet.filter(QueryDataSetObj => QueryDataSetObj['errorFields'] && Object.keys(QueryDataSetObj['errorFields']).length > 0);

    /* Final Validation Result */
    if(Object.keys(this.inquiryDataDetails.errorFields).length > 0 || QueryDataSetErrorArray.length > 0) {
      return false;
    }
    return true;
  }

  formatData(DataObject: any) {
    for (const key in DataObject) {
      const match = /(GMT.*\))/.exec(DataObject[key]);
      if(typeof DataObject[key] === 'object' && match && match.length > 0) {
        DataObject[key] = DataObject[key] ? format(new Date(DataObject[key]), 'yyyy-MM-dd') : '';
      } else if(typeof DataObject[key] === 'string') {
        DataObject[key] = DataObject[key] ? DataObject[key].trim() : '';
      } else if(typeof DataObject[key] === 'number') {
        DataObject[key] = DataObject[key];
      } else {
        DataObject[key] = DataObject[key] ? DataObject[key] : '';
      }
    }
  }

  
  isEmptyObject(ObjectParams: any): boolean | void {
    if(Object.keys(ObjectParams).length > 0) {
      for (let key in ObjectParams) {
        if (!_.includes(["errorFields", "status"], key) && (ObjectParams[key]!==null && ObjectParams[key]!=="")) {
          return false;
        }
      }
      return true;
    }
  }

  validateFields(dataObj: any, screenFields: any) {
    if(screenFields.length > 0) {
      if(!dataObj["errorFields"]) {
        dataObj["errorFields"] = [];
      }

      for(let i=0; i<screenFields.length; i++) {
        /* Required Field Validation */
          if(screenFields[i]["isrequired"]===true && screenFields[i]["isDisable"]!==true && (!dataObj[screenFields[i]['field_Name']] || dataObj[screenFields[i]['field_Name']]==="" || dataObj[screenFields[i]['field_Name']]===null || (screenFields[i]['datatype']==='Array' && dataObj[screenFields[i]['field_Name']].length===0))) {
            dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter required field";
            continue;
          } else if(screenFields[i]["isrequired"]===true && dataObj[screenFields[i]['field_Name']]) {
            delete dataObj["errorFields"][screenFields[i]['field_Name']];
          }
        /* End of Required Field Validation */

        /* Regex Field Validation */
          let validFieldFormat = false;
          if(screenFields["regexpressions"] && screenFields["regexpressions"].length > 0) {
            for(let j=0; j<screenFields[i]["regexpressions"].length; j++) {
              if(new RegExp(screenFields[i]["regexpressions"][j]).test(dataObj[screenFields[i]['field_Name']])===true) {
                validFieldFormat = true;
                delete dataObj["errorFields"][screenFields[i]['field_Name']];
              }
            }
            if(validFieldFormat === false) {
              dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter valid format";
              continue;
            }
          }
        /* End of Regex Field Validation */
      }
    }
  }

  saveInquiryWithFetchResult(APIParams: any) {
    let msg = 'Do you want to Save Inquiry with Generating its Result ?';
    this.confirmationService.confirm({
      message: msg,
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"confirm-dialog-button",
      rejectButtonStyleClass:"confirm-dialog-button",

      accept: () => {
        this.saveInquiryWithoutFetchResult(APIParams, true);
      },
      reject: () => {
        this.saveInquiryWithoutFetchResult(APIParams, false);
      }
    });
  }

  saveInquiryWithoutFetchResult(APIParams: any, isFetchResult: boolean) {
    this.isLoadingResults = true;

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.saveInquiry
      ), APIParams)
      .subscribe({
        next: (res:any) => {
          this.isLoadingResults = false;

        let dataset: any = res;
        if(dataset.status === true) {
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });

          this.selectedRegInquiryNodes = []; // Reset Selected Reg-Inquiries List
          this.changeDetector.detectChanges(); // After modifying selectedRegInquiryNodes

          // Call Fetch Result API If Applied Save With Fetching Result
          if(isFetchResult) {
            // Add User Action Log Entry for Saving Inquiry With Fetching Result
            this.UserService.logUserActivity('Save Inquiry', ('Edit Inquiry'), {
              'Text1': 'Saved Inquiry (' + this.inquiryDataDetails.tag + ' having ' + (this.queryDataSet.length > 0 ? this.queryDataSet.length : 0) + ' Queries) Successfully with Fetching Inquiry Result',
              'Text2': 'Completed Saving Inquiry with Fetching Inquiry Result'
            });
            this.fetchInquiryResult(dataset.inquiryId.toString());
          } else {
            // Add User Action Log Entry for Saving Inquiry Without Fetching Result
            this.UserService.logUserActivity('Save Inquiry', ('Edit Inquiry'), {
              'Text1': 'Saved Inquiry (' + this.inquiryDataDetails.tag + ' having ' + (this.queryDataSet.length > 0 ? this.queryDataSet.length : 0) + ' Queries) Successfully without Fetching Inquiry Result',
              'Text2': 'Completed Saving Inquiry without Fetching Inquiry Result'
            });
            this.reloadScreen.emit();
          }
        } else {
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
        }
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
      }
    });
  }

  fetchInquiryResult(InquiryIds: string) {
    let APIParams = {
      CATReporterIMID: this.UserService.getActiveMPID(),
      user: this.UserService.getUserName(),
      userName: this.UserService.getUserFirstName(),
      inquiryIds: InquiryIds.toString()
    };

    // Fetch Inquiry Initiation Acknowledgment Message
    this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_WARN, detail: 'Fetching Result has been started and may take time, result will display once Inquiry status will be completed, Please reload screen after some time.' });

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.fetchInquiryResult
      ), APIParams)
      .subscribe({
        next: (res:any) => {
          this.isLoadingResults = false;
          if(res.status === false) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: res.message });
          } else if (res.status === true) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: 'Fethcing Results may take time it will display once Inquiry status will be completed' });
            this.getInquiryQueryData(); // Retrieve Latest Inquiry List
            this.reloadScreen.emit();
          }
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
      }
    });
  }

  onFetchResult(): boolean | void {
    if(Object.keys(this.FinraInquiryServiceService.activeInquiry).length > 0) {
      let msg = '';
      /* Check Inquiry Executable Status */
        this.FinraInquiryServiceService.getInqiryExecutableStatus()
          .subscribe({
            next: (fetchResultExecutableElement: any) => {
              let fetchResultExecutableDataset: any = fetchResultExecutableElement;
              let fetchResultExecutableStatus = fetchResultExecutableDataset["status"];
  
              // Fetch Inquiry Result by checking Inquiry Result Execution Privilege condition
              if (fetchResultExecutableStatus === true) {
                msg = "Want to Fetch Result for " + this.FinraInquiryServiceService.activeInquiry.tag + " ?";

                this.confirmationService.confirm({
                  message: msg,
                  header: 'Confirmation',
                  acceptLabel: 'Yes',
                  acceptIcon:'pi pi-check',
                  defaultFocus: 'reject',
                  rejectLabel: 'No',
                  rejectIcon:'pi pi-times',
                  acceptButtonStyleClass:"confirm-dialog-button",
                  rejectButtonStyleClass:"confirm-dialog-button",

                  accept: () => {
                    this.isLoadingResults = true;
                
                    let executedInquiryIds = this.FinraInquiryServiceService.activeInquiry.inquiryId.toString();
                    if(executedInquiryIds.length > 0) {
                      this.fetchInquiryResult(executedInquiryIds);
                    }
                  },
                  reject: () => {
                  }
                });

              } else {
                msg = "Want to Fetch Result for " + this.FinraInquiryServiceService.activeInquiry.tag + " ?\n Fetching Result will be allowed for Regular Days in working hours (from 6 AM - 5 PM). Fetch results during regular business hours";

                this.confirmationService.confirm({
                  message: msg,
                  header: 'Confirmation',
                  acceptLabel: 'Yes',
                  acceptIcon:'pi pi-check',
                  defaultFocus: 'reject',
                  rejectLabel: 'No',
                  rejectIcon:'pi pi-times',
                  acceptButtonStyleClass:"confirm-dialog-button",
                  rejectButtonStyleClass:"confirm-dialog-button",

                  accept: () => {
                    this.isLoadingResults = false;
                    this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Not allowed Fetching Inquiry Result in non-working hours' });
                    this.UserService.logUserActivity("Fetch Inquiry Result", null, {
                      'Text1': this.UserService.userFirstName + ' not allowed to Fech Inquiry Result in non-working hours',
                      'Text2': ''
                    });
                  },
                  reject: () => {
                  }
                });
              }
            }, error: (err: HttpErrorResponse) => {
                this.isLoadingResults = false;
                this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Error while Fetching Inquiry Result' });
                this.UserService.logUserActivity('Fetch Inquiry Result', null, {
                  'Text1': 'Error while Fetching Inquiry Result',
                  'Text2': ''
                });
            }
          });
      /* End of Checking Inquiry Executable Status */
    } else {
      this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_WARN, summary: this.constantService.MESSAGE_SUMMARY_WARN, detail: 'Please Choose Inqiuries for fetching results.' });
    }
  }

  exportToCSV(event:any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: 'Please wait.. Preparing export file to download..' });

    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = this.previousLimit;
    }

    const filename='RSMS_Finra_Inqury_' + this.UserService.getyyyyMMddDateFormate(new Date());

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    let exportCSVPayload = {
      apiCall: 'ExportCSV',
      CATReporterIMID: this.UserService.getActiveMPID(),
      user: this.UserService.getUserName(),
      userName: this.UserService.getUserFirstName(),
      "data": filterData,
      rowDataObject: this.FinraInquiryServiceService.activeInquiry,
      sortField: this.sortData.field,
      sortOrder: this.sortData.order,
      startLimit: this.Limit.Start,
      endLimit: this.Limit.End
    };

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.getInquiryList
      ), exportCSVPayload)
      .subscribe({
        next: (Element:any) => {
        let dataset: any = Element;
        let data = dataset.Data;
        let detailsItems = this.prepareExportCSVData(data);
        if (data.length > 0) {
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title:filename,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            filename: filename
          };

          let headerColumns = event.gridColumn.filter((colObj: any) => !_.includes(['action', 'status', 'create date', 'update date', 'user', ''], colObj.ui_columnname.toLocaleLowerCase()) && colObj.display==="true");
          const csv = generateCsv(options)(this.constantService.getExportData(detailsItems, headerColumns));
          const blob = asBlob(options)(csv);
          saveAs(blob, filename);

          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: 'File Download Successfully' });
          this.UserService.logUserActivity('Export CSV', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'No data found' });
          this.UserService.logUserActivity('Export CSV', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
        this.emitterService.exportToCSVData.emit(true);
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Error while Exporting' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });
  }

  prepareExportCSVData(dataItems: any) {
    let detailsItems = [];

    // Check Parent Recrods
    if(dataItems.length > 0) {
      for(let i=0; i<dataItems.length; i++) {
        detailsItems.push(dataItems[i].data); // Add Parent-most Recrods
        // Check First-Level of Child Recrods
        if(dataItems[i].children && dataItems[i].children.length > 0) {
          for(let j=0; j<dataItems[i].children.length; j++) {
            detailsItems.push(dataItems[i].children[j].data); // Add First-Level of Child Recrods
            // Check Second-Level of Child Recrods
            if(dataItems[i].children[j].children && dataItems[i].children[j].children.length > 0) {
              for(let k=0; k<dataItems[i].children[j].children.length; k++) {
                detailsItems.push(dataItems[i].children[j].children[k].data); // Add Second-Level of Child Recrods
              }
            }
          }
        }
      }
    }

    return detailsItems;
  }

  onCellEditComplete(field: any, event: any, rowData: any) {
    this.isLoadingResults = true;

    this.formatData(rowData); // Foramatting RowObject for Inquiry/Inquiry-Query

    let rowType = ((rowData.parentLevel === 1) ? "Inquiry" : ((rowData.parentLevel === 2) ? "Inquiry-Query" : ""));

    let APIParams = {
      CATReporterIMID: this.UserService.getActiveMPID(),
      user: this.UserService.getUserName(),
      userName: this.UserService.getUserFirstName(),
      rowType: rowType,
      field: field,
      fieldValue: event,
      rowData: rowData
    };

    let recordType = (rowData.parentLevel === 1 ? "Inquiry" : (rowData.parentLevel === 2 ? "Query" : ""));

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.updateInquiryQuery
      ), APIParams)
      .subscribe({
        next: (res:any) => {
          if(res.status === false) {
            this.isLoadingResults = false;
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: res.message });
            this.UserService.logUserActivity('Update ' + recordType, null, {
              'Text1': 'Error while Updating ' + recordType,
              'Text2': 'User Filter Parameters: ' + JSON.stringify(rowData)
            });
          } else if (res.status === true) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: res.message });
            this.UserService.logUserActivity('Update ' + recordType, null, {
              'Text1': 'Updating ' + recordType + ' successfully',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(rowData)
            });
            this.getInquiryQueryData(); // Retrieve Latest Inquiry List
            this.reloadScreen.emit();
          }
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
      }
    });

  }

  exportSample() {
    let sampleData = [
      { "Sample #": 1, "Trade Date": "MM/DD/YYYY", "CAT Reporter IMID": this.UserService.getActiveMPID(), "Order ID": "XXXXXXXXXX-Y-ZZZ", "Route ID": "XXXXXXXXXX-Y-ZZZ", "Trade ID": "XXXXXXXXXX-Y-ZZZ", "Symbol": "XYZ", "Destination": "XYZ" },
    ];

    const csvHeaders = Object.keys(sampleData[0]);
    const csvHeaderRow = csvHeaders.join(',');

    const csvDataRows = sampleData.map((row: any) =>
      csvHeaders.map(header => row[header]).join(',')
    );

    let csvContent = [csvHeaderRow, ...csvDataRows].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Using file-saver
    saveAs(blob, 'Sample-Inquiry.csv');
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.HTTPInquirySubscribedAPI) {
      this.HTTPInquirySubscribedAPI.unsubscribe();
    }
    if (this.HTTPSubscribedAPI) {
      this.HTTPSubscribedAPI.unsubscribe();
    }
  }

}